export default (activeAnchorList) => {

  const a = {}
  a.anchorList = activeAnchorList;
  const init = () => {
    if (a.anchorList.length == 1) {
      document.getElementById('result').remove();
      document.getElementById('anchor').remove();
      return;
    }

    const pageAnchorList = document.getElementById('anchor');
    const pageAnchorLinks = pageAnchorList.querySelectorAll('.le-round-anchor__link');
    pageAnchorLinks.forEach(link => {
      const anchoTargetName = link.dataset.key;
      if ( !a.anchorList.includes(anchoTargetName) ) {
        const swapWrapElement = document.createElement('div');
        swapWrapElement.classList.add(...(link.className.split(' ')), '_disabled');
        swapWrapElement.innerHTML = link.innerHTML;
        const parentElement = link.parentElement;
        parentElement.innerHTML = '';
        parentElement.appendChild(swapWrapElement);
      }
    });
  }

  init();
}
